<script>
import PriceListItem from "@js/components/Sections/PriceList/Components/PriceListItem.vue";

export default {
  name: "PriceList",
  components: {PriceListItem},
  data() {
    return {
      showAll: false, // Состояние для управления отображением всех элементов
      items: Array.from({length: 9}, (_, i) => i + 1), // Поменять потом на реальные данные
      min_items_count: 9,
    };
  }
};
</script>

<template>
  <div class="container pt-10">
<!--    <div class="relative mb-16">-->
<!--        <h2 class="text-2xl md:text-3xl font-bold text-center mb-5 md:mb-0">-->
<!--          Хиты продаж-->
<!--        </h2>-->
<!--    </div>-->
    <div class="grid grid-cols-2 lg:grid-cols-3 gap-5 mb-5">
      <template v-for="item in items" :key="item">
        <PriceListItem/>
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
</style>
